export default "__VITE_ASSET__B2OqezuT__"